// @ts-expect-error
const ApiBaseUrl = config.apiBaseUrl;

const CommonBase = `${ApiBaseUrl}/api_CorporatePortal/common`;

class Routes {
    ApiBaseUrl: string = ApiBaseUrl;

    Common: Record<string, string> = {
        GetGlobalFeatures: `${CommonBase}/getGlobalFeatures`
    };
    Claims: Record<string, string> = {
        GetClaims: `${ApiBaseUrl}/api_CorporatePortal/v1/ReportAClaim`
    };
    HOClaims: Record<string, string> = {
        PolicyExistence: `${ApiBaseUrl}/api-hoclaims/v2/common/token/fnol`
    };
    FloodClaims: Record<string, string> = {
        PolicyExistence: `${ApiBaseUrl}/api-floodclaims/common/fnol/token`
    };
    InformationBanner: Record<string, string> = {
        GetBanners: `${ApiBaseUrl}/api-webbanner/v1/WebBanner/GetActiveWebBanners`
    }
}

export const ApiRoutes = new Routes();
